import { render, staticRenderFns } from "./certificateView.vue?vue&type=template&id=38ae65c1&"
import script from "./certificateView.vue?vue&type=script&lang=js&"
export * from "./certificateView.vue?vue&type=script&lang=js&"
import style0 from "./certificateView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports